<template>
  <nav class="navbar navbar-default position-fixed __navbarbg">
    <div class="container-fluid __navpadding">
    <div class="navbar-header">
      <router-link  class="navbar-brand" to="/dashboard">
        <img class="__logoandalin" src="@/assets/image/logos Andalin 2@3x.png" alt="">
      </router-link>
    </div>

    <div class="d-flex align-items-center flex-row ">
      <div class="__customdropdown_nav ">
        <!-- <b-input-group>
          <b-dropdown>
          <template slot="button-content">
            <span class="__btn_language m-0">{{languageValue}}</span> <img class="__imgArrow" src = "../../assets/image/instantprice/right-arrow.svg">
          </template>
          <b-dropdown-item class="d-flex align-items-center" v-on:click="selectedOption(option.text)" v-for="option in optionLanguage" :key="option.id">
            <span>{{ option.text }}</span>
          </b-dropdown-item>
          </b-dropdown>
        </b-input-group> -->
      </div>
      <div class="row m-0 nav__andalinpoints" v-if="isAuthenticated && profile.status === 'ANDALINVERIFICATION'">
        <AlibabaTour />
        <router-link v-if="canAccessAndalinPoints()" :to="{name: 'AndalinPoints'}" tag="div" id="tooltip-andalinpoint"
                     class="global__andalinpoints d-flex align-items-center">
          <img class="__avatar" src="@/assets/image/image/andalin-point.png">
          <div v-if="isLoadingpoint" class="spinner__small--blue">
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <p v-else-if="pointItem">{{ pointItem.totalPoint || 0 }} <span class="pl-2">AndalinPoints</span> </p>
          <p v-else>0 <span class="pl-2">AndalinPoints</span> </p>
        </router-link>
        <b-tooltip id="andalin-point" show target="tooltip-andalinpoint" placement="bottomright">
            <span>Special Redeem Voucher</span> Available !<br>
            Enjoy discount point and get your voucher now.
        </b-tooltip>
      </div>
      <div class="__avatar_container d-flex align-items-center" v-if="isAuthenticated && account">
       <router-link to="/settings/myaccount" >
          <img class="__avatar" v-if="account.photo" :src="getImageAWS(account.photo)" alt="">
          <img class="__avatar" src="@/assets/image/avatar@3x.png" v-else>
        </router-link>
      </div>
      <div class="__customdropdown_nav" v-if="isAuthenticated">
        <b-input-group>
          <b-dropdown>
          <template slot="button-content">
            <span class="__btn_language m-0">{{  profile.customerName || profile.codeUserType }}</span> <img class="__imgArrow ml-2" src = "../../assets/image/icon/small-down.svg">
          </template>
          <b-dropdown-item class="d-flex align-items-center justify-content-between" @click="handleLogout()"><span>Logout</span><img class="__poweroff" src="@/assets/image/icon/power-off.svg" alt=""></b-dropdown-item>
          </b-dropdown>
        </b-input-group>
      </div>
    </div>
  </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import AlibabaTour from '@/components/global/AlibabaTour.vue'
import mixin from '@/mixin'

export default {
  name: 'navbar',
  components: {
    AlibabaTour
  },
  mixins: [mixin],
  data () {
    return {
      languageValue: 'English',
      optionLanguage: [
        { id: 1, text: 'English', value: '' },
        { id: 2, text: 'Bahasa Indonesia', value: '' }
      ],
      andalinPoint: 0
    }
  },
  methods: {
    selectedOption: function (event) {
      this.languageValue = event
    },
    fetchAccount () {
      this.$store.dispatch('settingAccount/FETCH_ACCOUNT')
    },
    handleLogout: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let payload = ''
          let profile = ''
          if (this.profile.codeUserType === 'GUEST') {
            payload = { userId: this.profile.userId }
            profile = { mail: this.profile.customerUsername, shipment: this.profile.shipmentId }
          } else {
            payload = { username: this.profile.customerUsername }
          }
          this.$store.dispatch('auth/AUTH_LOGOUT', { payload, profile, typeLogout: this.profile.codeUserType === 'GUEST' ? 'guest' : 'auth' })
          return
        }
        alert('Cannot logout!')
      })
    },
    fetchPointItem () {
      this.$store.dispatch('andalinpoint/FETCH_POINT')
    }
  },
  mounted () {
    if (this.isAuthenticated && this.profile.codeUserType !== 'GUEST') {
      this.fetchAccount()
      if (this.account) {
        this.fetchPointItem()
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuth',
      profile: 'auth/profile',
      errorAunt: 'auth/error',
      isLoading: 'auth/isLoading',

      account: 'settingAccount/account',
      errorAccount: 'settingAccount/error',
      isLoadingAccount: 'settingAccount/isLoading',

      pointItem: 'andalinpoint/pointitem',
      isLoadingpoint: 'andalinpoint/isLoadingpoint',
      isErrorpoint: 'andalinpoint/errorpoint',

      redeemPoint: 'andalinpoint/redeemPoint',
      isLoadingredeemPoint: 'andalinpoint/isLoadingredeemPoint',
      errorredeemPoint: 'andalinpoint/errorredeemPoint'
    })
  },
  watch: {
    isAuthenticated (data) {
      if (data && this.profile.codeUserType !== 'GUEST') {
        this.fetchAccount()
      // if (data && this.profile.showSurvey === 1) {
      //   this.$eventHub.$emit('dialog-survey')
      // }
      }
    },
    account (data) {
      if (data && this.isAuthenticated) {
        this.fetchPointItem()
      }
    },
    redeemPoint (data) {
      if (data) {
        this.fetchPointItem()
      }
    },
    pointItem (data) {
      if (data) {
        this.pointItem.totalPoint = data.totalPoint
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/Navbar.vue